import type { ConnectorModel } from '@/adapters/apiv1.g';
import type { Connector } from '@/types/core/connector';
import type { LogoAsset } from '@/types/shared/logo';
import type { UUID } from '@/utils/uuid';

function extractLogo(model: ConnectorModel): LogoAsset | undefined {
  const light = model.provider_logo_light_uri?.trim();
  const dark = model.provider_logo_dark_uri?.trim();
  if (!light || !dark) {
    return undefined;
  }

  return {
    light,
    dark,
  };
}

/**
 * Transform a backend ConnectorModel to a frontend Connector type.
 * Handles snake_case to camelCase conversion and provides safe defaults.
 * @param model - API ConnectorModel response
 * @returns Connector - UI-friendly Connector object
 */
export function extractConnector(model: ConnectorModel): Connector {
  return {
    _rev: model._rev,
    id: (model.connector_id ?? '') as UUID,
    providerId: (model.provider_id ?? '') as UUID,
    providerName: model.provider_name ?? '',
    logo: extractLogo(model),
    name: model.name ?? model.provider_name ?? '',
    requirements: model.requirements ?? [],
    requiredSites: model.required_sites ?? [],
    status: model.enabled ?? false,
    is_system: model.is_system,
    isInternal: model.is_internal,
  };
}
